import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const connectedHomeRenewal: TaskDefinition = {
  taskName: onboardingTasks.ConnectedHomeRenewal,
  config: {
    staffDisplayName: 'Proof of Connected Home for renewal',
    appcuesModalId: '8417a4bd-f165-48c3-a01c-a845f2ff0029',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    eventName: 'Provided Proof of Connected Home for Renewal',
    account: {
      toastMessage: 'Your proof of connected home documents have been submitted for review.',
      affectedPoliciesLeadText: 'Renewal of',
      content: ({ affectedPolicies, formattedDeadline }) => ({
        title: 'Proof of Connected Home',
        incompleteSubtitle:
          'Secure your discount before your policy renewal by providing proof of your professional home monitoring system.',
        completedSubtitle: `Thanks for submitting your documents for review. We'll validate your home discount for the renewal of ${affectedPolicies}.`,
        deniedSubtitle: `Your professional home monitoring system could not be verified with the provided documents. The discount will not be applied for ${affectedPolicies}.`,
        actionLabel: 'Upload proof',
        modalTitle: 'Upload your proof of Connected Home',
        contentSections: [
          {
            title: 'What documents are accepted?',
            body: 'Alarm certificate, available through your home monitoring provider'
          },
          {
            title: 'When do I need to submit these documents?',
            body: `You have until ${formattedDeadline} to turn in verification listed above or the discount will be removed on your next policy term.`
          }
        ]
      })
    }
  }
};
